import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import CloseIcon from "./components/NotIncludedIcon/NotIncludedIcon";
import IncludedIcon from "./components/IncludedIcon";
import SelectControl from "../../fragments/Form/components/SelectControl";
import getClassNameFactory from "../../utilities/classNames";
import { ComparisonGrid } from "./components/ComparisonGrid";
import PlanInfo from "./components/PlanInfo";
import classNames from "classnames";
import ColumnHeader from "./components/ColumnHeader/ColumnHeader";
import FeatureCell from "./components/FeatureCell/FeatureCell";
import MobileHeaderRow from "./components/MobileHeaderRow";
var MIN_PRODUCTS_FOR_SELECT_CONTROL = 2;

var PlanComparisonTable = /*#__PURE__*/function (_Component) {
  _inherits(PlanComparisonTable, _Component);

  var _super = _createSuper(PlanComparisonTable);

  function PlanComparisonTable(props) {
    var _this;

    _classCallCheck(this, PlanComparisonTable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      if (window && window.innerWidth) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isMobile: document.documentElement.clientWidth < _this.mobileScreenBreakpoint
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      var columnH = _this.tableRef.current.querySelector("#column-header");

      var _columnH$getBoundingC = columnH.getBoundingClientRect(),
          height = _columnH$getBoundingC.height,
          top = _columnH$getBoundingC.top;

      var headerRow = _this.tableRef.current.querySelector("thead tr[class*=ComparisonGrid-row--header]:first-child");

      var headerCoordinates = headerRow.getBoundingClientRect();

      if (Math.abs(top) > height && !_this.state.isScrolled && top < 0) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isScrolled: true
          });
        });
      } else if (Math.abs(top) < height && _this.state.isScrolled) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isScrolled: false
          });
        });
      }

      var SHADOW_THRESHOLD = 0;

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          showShadow: headerCoordinates.top <= SHADOW_THRESHOLD && _this.props.stickyHeader
        });
      });
    });

    _this.state = {
      isMobile: false,
      isScrolled: false,
      compareP1: 0,
      compareP2: 1,
      isVisible: true,
      showShadow: false
    };
    _this.tableRef = /*#__PURE__*/React.createRef(); // checks if the table is visible

    _this.observer = new MutationObserver(function () {
      if (_this.tableRef.current.clientHeight && !_this.state.isVisible) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isVisible: true
          });
        });
      } else if (!_this.tableRef.current.clientHeight && _this.state.isVisible) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isVisible: false
          });
        });
      }
    });
    _this.mobileScreenBreakpoint = 768;
    _this.getClassName = getClassNameFactory(PlanComparisonTable.displayName);
    return _this;
  }

  _createClass(PlanComparisonTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleWindowResize();

      if (!this.tableRef.current.clientHeight) {
        this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isVisible: false
          });
        });
      }

      var targetNode = this.tableRef.current.closest(".emcmUi-TabsPanel");

      if (targetNode) {
        this.observer.observe(targetNode, {
          attributes: true
        });
      }

      window.addEventListener("scroll", this.handleScroll, {
        passive: true
      });

      if (window) {
        window.addEventListener("resize", this.handleWindowResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener("resize", this.handleWindowResize);
      }

      window.removeEventListener("scroll", this.handleScroll);
      this.observer.disconnect();
    }
  }, {
    key: "onSelectPlan1ToCompare",
    value: function onSelectPlan1ToCompare(target) {
      this.setState({
        compareP1: Number(target.value)
      });
    }
  }, {
    key: "onSelectPlan2ToCompare",
    value: function onSelectPlan2ToCompare(target) {
      this.setState({
        compareP2: Number(target.value)
      });
    }
  }, {
    key: "getSelectControl",
    value: function getSelectControl(compare) {
      var _this2 = this;

      var _this$props$products = this.props.products,
          products = _this$props$products === void 0 ? [] : _this$props$products;
      var _this$state = this.state,
          compareP1 = _this$state.compareP1,
          compareP2 = _this$state.compareP2;
      var options = products.map(function (product, index) {
        return {
          value: String(index),
          label: product === null || product === void 0 ? void 0 : product.name
        };
      });
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "select-plan"
        })
      }, /*#__PURE__*/React.createElement(SelectControl, {
        id: "select-plan-".concat(compare),
        name: "select-plan-".concat(compare),
        labelText: "",
        optionalText: "",
        options: options,
        onChange: function onChange(e) {
          return compare === "P1" ? _this2.onSelectPlan1ToCompare(e) : _this2.onSelectPlan2ToCompare(e);
        },
        value: compare === "P1" ? options[compareP1].value : options[compareP2].value
      }));
    }
  }, {
    key: "getPlanHeader",
    value: function getPlanHeader(product, compare) {
      var _this3 = this;

      var _this$props$products2 = this.props.products,
          products = _this$props$products2 === void 0 ? [] : _this$props$products2;
      var isMobile = this.state.isMobile;
      var id = isMobile ? compare : product.productId;
      return {
        id: id,
        columns: [{
          Header: "",
          accessor: id,
          cellProps: isMobile ? {
            colSpan: compare === "P1" ? "2" : "1"
          } : {}
        }],
        Header: function Header() {
          return /*#__PURE__*/React.createElement("div", {
            className: _this3.getClassName({
              descendantName: "plan-container"
            })
          }, isMobile && products.length > MIN_PRODUCTS_FOR_SELECT_CONTROL && _this3.getSelectControl(compare), /*#__PURE__*/React.createElement(PlanInfo, {
            planName: product.name,
            price: product.price,
            priceInfo: product.priceInfo,
            description: product.description,
            actionLabel: product.actionLabel,
            ariaLabel: product.ariaLabel,
            target: product.target,
            actionButtonProps: product.actionButtonProps
          }));
        }
      };
    }
  }, {
    key: "getColumns",
    value: function getColumns() {
      var _this4 = this;

      var _this$props = this.props,
          _this$props$products3 = _this$props.products,
          products = _this$props$products3 === void 0 ? [] : _this$props$products3,
          _this$props$firstColu = _this$props.firstColumnHeader,
          firstColumnHeader = _this$props$firstColu === void 0 ? {} : _this$props$firstColu,
          dropdownId = _this$props.dropdownId;
      var columns = [];

      var columnHeaderProps = _objectSpread(_objectSpread({}, firstColumnHeader), {}, {
        id: dropdownId
      });

      columns.push({
        id: "colFeatures",
        Header: function Header() {
          return /*#__PURE__*/React.createElement(ColumnHeader, columnHeaderProps) || "";
        },
        columns: [{
          Header: "",
          accessor: "colFeatures"
        }]
      });
      products.forEach(function (product) {
        columns.push(_this4.getPlanHeader(product));
      });
      return columns;
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this5 = this;

      var data = [];
      var bodyData = this.props.bodyData;
      bodyData.forEach(function (row) {
        var _row$rowHeader = row.rowHeader,
            rowHeader = _row$rowHeader === void 0 ? false : _row$rowHeader,
            featureCell = row.featureCell,
            cells = row.cells;
        var content;
        var formattedCells = {};
        cells.forEach(function (cell, key) {
          if (rowHeader) {
            if (key === 0) {
              // when rowHeader first cell is content (colFeatures column)
              content = /*#__PURE__*/React.createElement("div", {
                header: rowHeader
              }, cell === null || cell === void 0 ? void 0 : cell.content);
            } else {
              formattedCells[key] = /*#__PURE__*/React.createElement("div", {
                header: rowHeader
              }, cell === null || cell === void 0 ? void 0 : cell.content);
            }
          } else {
            content = /*#__PURE__*/React.createElement("div", {
              header: true
            }, /*#__PURE__*/React.createElement(FeatureCell, {
              name: featureCell.name,
              listOptions: featureCell.listOptions,
              showInfoIcon: featureCell.showInfoIcon,
              modal: featureCell.modal
            }));
            formattedCells[key + 1] =
            /*#__PURE__*/
            // key +1 matches product id used for column identifier
            React.createElement("div", null, (cell === null || cell === void 0 ? void 0 : cell.included) === true && /*#__PURE__*/React.createElement(IncludedIcon, {
              height: 18
            }), (cell === null || cell === void 0 ? void 0 : cell.included) === false && /*#__PURE__*/React.createElement(CloseIcon, {
              height: 18
            }), /*#__PURE__*/React.createElement("p", null, cell === null || cell === void 0 ? void 0 : cell.content));
          }
        });
        data.push(_objectSpread({
          colFeatures: content,
          rowProps: {
            className: rowHeader && _this5.getClassName({
              descendantName: "header-row"
            })
          }
        }, formattedCells));
      });
      return data;
    }
  }, {
    key: "getMobilecolumns",
    value: function getMobilecolumns() {
      var _this$props$products4 = this.props.products,
          products = _this$props$products4 === void 0 ? [] : _this$props$products4;
      var _this$state2 = this.state,
          compareP1 = _this$state2.compareP1,
          compareP2 = _this$state2.compareP2;
      var columns = [];
      columns.push(this.getPlanHeader(products[compareP1], "P1"));

      if (products[compareP2]) {
        columns.push(this.getPlanHeader(products[compareP2], "P2"));
      }

      return columns;
    }
  }, {
    key: "getMobileData",
    value: function getMobileData() {
      var _this6 = this;

      var _this$state3 = this.state,
          compareP1 = _this$state3.compareP1,
          compareP2 = _this$state3.compareP2;
      var data = [];
      var bodyData = this.props.bodyData;
      bodyData.forEach(function (row) {
        var _row$rowHeader2 = row.rowHeader,
            rowHeader = _row$rowHeader2 === void 0 ? false : _row$rowHeader2,
            featureCell = row.featureCell,
            cells = row.cells;
        var content;

        if (rowHeader) {
          var _cells$, _cells, _cells2;

          content = /*#__PURE__*/React.createElement("div", {
            header: rowHeader
          }, /*#__PURE__*/React.createElement(MobileHeaderRow, {
            headerLabel: (_cells$ = cells[0]) === null || _cells$ === void 0 ? void 0 : _cells$.content,
            labelP1: (_cells = cells[compareP1 + 1]) === null || _cells === void 0 ? void 0 : _cells.content,
            labelP2: (_cells2 = cells[compareP2 + 1]) === null || _cells2 === void 0 ? void 0 : _cells2.content
          }));
          data.push({
            P1: content,
            rowProps: {
              className: _this6.getClassName({
                descendantName: "header-row"
              })
            },
            cellProps: {
              colSpan: 2
            }
          });
        } else {
          content = /*#__PURE__*/React.createElement("div", {
            header: true
          }, /*#__PURE__*/React.createElement(FeatureCell, {
            name: featureCell.name,
            listOptions: featureCell.listOptions,
            showInfoIcon: featureCell.showInfoIcon,
            modal: featureCell.modal
          }));
          data.push({
            P1: content,
            rowProps: {
              className: _this6.getClassName({
                descendantName: "feature-row"
              })
            },
            cellProps: {
              colSpan: 2,
              scope: "row"
            }
          });
          data.push({
            P1: _this6.renderFeatureCell(cells[compareP1]),
            P2: _this6.renderFeatureCell(cells[compareP2])
          });
        }
      });
      return data;
    }
  }, {
    key: "renderMobileRowHeader",
    value: function renderMobileRowHeader() {
      var _products$compareP, _products$compareP2;

      var _this$props2 = this.props,
          _this$props2$products = _this$props2.products,
          products = _this$props2$products === void 0 ? [] : _this$props2$products,
          firstColumnHeader = _this$props2.firstColumnHeader;
      var _this$state4 = this.state,
          compareP1 = _this$state4.compareP1,
          compareP2 = _this$state4.compareP2;
      return /*#__PURE__*/React.createElement(MobileHeaderRow, {
        headerLabel: firstColumnHeader === null || firstColumnHeader === void 0 ? void 0 : firstColumnHeader.headerLabel,
        labelP1: (_products$compareP = products[compareP1]) === null || _products$compareP === void 0 ? void 0 : _products$compareP.headerLabel,
        labelP2: (_products$compareP2 = products[compareP2]) === null || _products$compareP2 === void 0 ? void 0 : _products$compareP2.headerLabel
      });
    }
  }, {
    key: "renderFeatureCell",
    value: function renderFeatureCell(feat) {
      return /*#__PURE__*/React.createElement("div", null, (feat === null || feat === void 0 ? void 0 : feat.included) === true && /*#__PURE__*/React.createElement(IncludedIcon, {
        height: 18
      }), (feat === null || feat === void 0 ? void 0 : feat.included) === false && /*#__PURE__*/React.createElement(CloseIcon, {
        height: 18
      }), /*#__PURE__*/React.createElement("p", null, feat === null || feat === void 0 ? void 0 : feat.content));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          stickyHeader = _this$props3.stickyHeader,
          _this$props3$products = _this$props3.products,
          products = _this$props3$products === void 0 ? [] : _this$props3$products,
          firstColumnHeader = _this$props3.firstColumnHeader,
          ariaLabelledByText = _this$props3.ariaLabelledByText;
      var _this$state5 = this.state,
          isMobile = _this$state5.isMobile,
          isScrolled = _this$state5.isScrolled,
          isVisible = _this$state5.isVisible,
          dropdownId = _this$state5.dropdownId,
          showShadow = _this$state5.showShadow;
      var columns = isMobile ? this.getMobilecolumns() : this.getColumns();
      var rowData = isMobile ? this.getMobileData() : this.getData();

      var columnHeaderProps = _objectSpread(_objectSpread({}, firstColumnHeader), {}, {
        dropdownId: dropdownId
      });

      var caption = /*#__PURE__*/React.createElement(ColumnHeader, columnHeaderProps);
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          states: classNames({
            stickyHeader: stickyHeader,
            oneProd: products.length === 1,
            colSize: isMobile ? false : products.length > 1,
            mobile: isMobile,
            scrolled: isScrolled,
            notVisible: !isVisible,
            showShadow: showShadow
          })
        }),
        ref: this.tableRef
      }, /*#__PURE__*/React.createElement(ComparisonGrid, {
        caption: isMobile ? caption : null,
        columns: columns,
        data: rowData,
        useDefaultColspan: true,
        getHeaderProps: function getHeaderProps(row) {
          return row === null || row === void 0 ? void 0 : row.cellProps;
        },
        getRowProps: function getRowProps(row) {
          var _row$original;

          return row === null || row === void 0 ? void 0 : (_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.rowProps;
        },
        getCellProps: function getCellProps(cell) {
          var _cell$row, _cell$row$original;

          return cell === null || cell === void 0 ? void 0 : (_cell$row = cell.row) === null || _cell$row === void 0 ? void 0 : (_cell$row$original = _cell$row.original) === null || _cell$row$original === void 0 ? void 0 : _cell$row$original.cellProps;
        },
        ariaLabelledBy: ariaLabelledByText ? ariaLabelledByText : "Comparison Table Header"
      }));
    }
  }]);

  return PlanComparisonTable;
}(Component);

_defineProperty(PlanComparisonTable, "displayName", "PlanComparisonTable");

_defineProperty(PlanComparisonTable, "propTypes", {
  stickyHeader: PropTypes.bool,

  /**
   * First Cell in the header
   */
  firstColumnHeader: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    dropdownProps: PropTypes.shape({
      labelText: PropTypes.string,
      instructionalText: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })),
      onChange: PropTypes.func
    })
  }),

  /**
   * Products to compare
   */
  products: PropTypes.arrayOf(PropTypes.shape({
    productId: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.string,
    description: PropTypes.string,
    actionLabel: PropTypes.string,
    ariaLabel: PropTypes.string,
    target: PropTypes.string,
    actionButtonProps: PropTypes.any
  })),

  /**
   * Features to display in the first column
   */
  bodyData: PropTypes.arrayOf(PropTypes.shape({
    rowHeader: PropTypes.bool,
    featureCell: PropTypes.shape({
      name: PropTypes.string,
      showInfoIcon: PropTypes.bool,
      listOptions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        modal: PropTypes.shape({
          title: PropTypes.string,
          subTitle: PropTypes.string,
          content: PropTypes.string,
          okBtnLabel: PropTypes.string,
          cancelBtnLabel: PropTypes.string,
          onPressOkBtn: PropTypes.func,
          onPressCancelBtn: PropTypes.func,
          onClose: PropTypes.func
        })
      })),
      modal: PropTypes.shape({
        title: PropTypes.string,
        subTitle: PropTypes.string,
        content: PropTypes.string,
        okBtnLabel: PropTypes.string,
        okBtnLink: PropTypes.string,
        okBtnTarget: PropTypes.string,
        cancelBtnLabel: PropTypes.string,
        cancelBtnLink: PropTypes.string,
        cancelBtnTarget: PropTypes.string,
        onPressOkBtn: PropTypes.func,
        onPressCancelBtn: PropTypes.func,
        onClose: PropTypes.func
      })
    }),
    cells: PropTypes.arrayOf(PropTypes.shape({
      included: PropTypes.bool,
      content: PropTypes.string
    }))
  })),

  /**
   * aria-labelledby attribute for the table
   */
  ariaLabelledByText: PropTypes.string,

  /** id for the first column dropdown  */
  dropdownId: PropTypes.string
});

export default PlanComparisonTable;